import React, { Component, useState, useMemo, useEffect } from 'react';

import { fetchData } from "../common/networkRequests";
import { createComponent } from "../FormArea/FormContent/index";
import './ModalStyle.css';
import { FaArrowDown, FaRegWindowRestore } from "react-icons/fa";

import { getObjectsValue, clearDisplayData, forceClearData, calculateInterest, padding, RelevantIcon } from '../oro-module/commonFunctions';
import AutoComponent from '../common/AutoComponent';

import { controls } from "../../pages/controls";


const DashboardsGenerator = (props) => {

  let [widgets, setWidgets] = useState([]);
  let [isloading, setisloading] = useState(false);


  let { currentPage } = props.parentState;
  let { sequence } = props.component;
  let { portal } = props.parentProps.parentState.profile;

  const internallySetWidgets = (data) => {
    let all_widgets = [];
    let { results } = data;

    for (var i = 0; i < results.length; i++) {
      let oro_widget_parameters = {}

      let widget = results[i];
      let oro_widget =
      {
        // widths: widget.width ? `col-sm-${widget.width}` : "col-sm-6",
        widths: (widget.width && widget.width == 6) ? `col-lg-6 col-md-12` : (widget.width && widget.width == 12) ? `col-lg-12` : "col-lg-6 col-md-12",
        tab: "create",
        title: widget.title_text,
        footer: widget.footer_text ? widget.footer_text : "",
        theme: widget.theme ? widget.theme : "",
        selfWhatsApp: "sendsummary",
        title2name: widget.title_tag_field ? widget.title_tag_field : ""
      };

      if (widget.widget_type == 'list') {
        // if widget.pivot_at, then create multiple widgets for each pivot.
        oro_widget_parameters['showValues'] = true;
        oro_widget_parameters['clickable'] = widget.label.clickable;
        oro_widget_parameters['name'] = "kpi_list";
        oro_widget_parameters['ddType'] = widget.form;
        oro_widget_parameters['dformat'] = { label: "display_label", format: "aduitorchecklist", lift: { completeBy: "insdeadline" }, fastpath: "fastpath", value: "status", displayType: "tick", hasvar3: "label_uid" };
        oro_widget_parameters['reportName'] = widget.form;
        oro_widget_parameters['query_group'] = widget.query_group;

        oro_widget_parameters['pivot_at'] = widget.pivot_at;

        oro_widget_parameters['emptymsg'] = widget.emptymsg ? widget.emptymsg : false;
        oro_widget_parameters['format'] = { label: widget.label, value: widget.value }; // as received from db.

        oro_widget.subComponents = [...controls.listWidget(oro_widget_parameters)];

      } else if (widget.widget_type == 'nbar') {

        oro_widget_parameters["reportName"] = widget.form;
        oro_widget_parameters['query_group'] = widget.query_group;

        oro_widget_parameters["label_field"] = widget.label_field;
        oro_widget_parameters["axes_labels"] = widget.axes_labels;
        oro_widget_parameters["legend"] = widget.legend;
        oro_widget_parameters["column_defs"] = widget.column_defs;
        oro_widget_parameters["index_by"] = widget.index_by;
        oro_widget_parameters["aria_label"] = widget.aria_label;
        oro_widget_parameters["width"] = (widget.width && widget.width == 6) ? `col-lg-6 col-md-12` : (widget.width && widget.width == 12) ? `col-lg-12` : "col-lg-6 col-md-12";
        oro_widget.subComponents = [...controls.barChart(oro_widget_parameters)];
      }
      else if (widget.widget_type == 'progressbar') {
        oro_widget_parameters["reportName"] = widget.form;
        oro_widget_parameters['query_group'] = widget.query_group;

        oro_widget_parameters["label_field"] = widget.label_field;
        oro_widget_parameters["pct_labels"] = widget.pct_labels;
        oro_widget_parameters["subtotal_definitions"] = widget.subtotal_definitions; // []
        oro_widget_parameters["is_pct"] = widget.is_pct;
        oro_widget.subComponents = [...controls.progressBarCustom(oro_widget_parameters)];
      }
      else if (widget.widget_type == 'gmap') {
        oro_widget_parameters["reportName"] = widget.form;
        oro_widget.subComponents = [...controls.gmapWidget(oro_widget_parameters)];
      }
      all_widgets.push(oro_widget)
    }
    setWidgets(all_widgets);
    setisloading(false);
  }

  const setWidgetsFromOutside = () => {
    setisloading(true);
    let saveThis = { dataType: 'userdashboards', currentPage, showAll: true, sequence, portal };
    fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: internallySetWidgets });
  }

  useEffect(() => setWidgetsFromOutside(), []);

  // console.log("RENDERED DashboardsGenerator")
  return (
    <div className={`form-group col-sm-12`} style={{ padding: 0 }}>
      {!isloading && widgets.length != 0 && createComponent({
        style: { padding: 0 },
        allc: widgets,
        current: { props }
      })
      }

      {!isloading && widgets.length == 0 && <div className="empty_dashboard">Dashboard is not customized . . . </div>}
      {isloading &&
        <div>loading . . .</div>
      }
    </div>

  )
}


export default DashboardsGenerator;